// Shared existing organisation coverage for web and native phase views.

export function getDescendantIds(positions, positionId) {
  const descendants = new Set();
  const queue = [positionId];
  while (queue.length > 0) {
    const current = queue.shift();
    for (const p of positions) {
      if (p.parentId === current && !descendants.has(p.id)) {
        descendants.add(p.id);
        queue.push(p.id);
      }
    }
  }
  return descendants;
}

export function getAllPositions(orgCharts) {
  const allPositions = [];
  for (const oc of orgCharts) {
    for (const pos of (oc.nodes || [])) {
      allPositions.push(pos);
    }
  }
  return allPositions;
}

export const resolveOrgScope = (userId, allPositions, allClasses = []) => {
  if (!userId || !allPositions || allPositions.length === 0) {
    return { myPositionIds: new Set(), assignmentClassIds: new Set(), scopeClassIds: new Set() };
  }

  const myPositionIds = new Set();
  for (const pos of allPositions) {
    if ((pos.staffCards || []).some(sc => sc.uid === userId)) {
      myPositionIds.add(pos.id);
    }
  }

  // Helper: resolve gradeCards on a position to class IDs
  const resolveGradeClassIds = (pos) => {
    const ids = [];
    for (const gc of (pos.gradeCards || [])) {
      for (const cls of allClasses) {
        if (cls.grade === gc.gradeId) ids.push(cls.id);
      }
    }
    return ids;
  };

  const assignmentClassIds = new Set();
  for (const pos of allPositions) {
    if (myPositionIds.has(pos.id)) {
      for (const cc of (pos.classCards || [])) {
        assignmentClassIds.add(cc.classId);
      }
      for (const id of resolveGradeClassIds(pos)) {
        assignmentClassIds.add(id);
      }
    }
  }

  const scopeClassIds = new Set(assignmentClassIds);
  for (const positionId of myPositionIds) {
    const descendantIds = getDescendantIds(allPositions, positionId);
    for (const descId of descendantIds) {
      const descPos = allPositions.find(p => p.id === descId);
      if (descPos) {
        for (const cc of (descPos.classCards || [])) {
          scopeClassIds.add(cc.classId);
        }
        for (const id of resolveGradeClassIds(descPos)) {
          scopeClassIds.add(id);
        }
      }
    }
  }

  return { myPositionIds, assignmentClassIds, scopeClassIds };
};
